import script from "./CustomerServiceView.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerServiceView.vue?vue&type=script&setup=true&lang=js"

import "./CustomerServiceView.vue?vue&type=style&index=0&id=01835586&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01835586"]])

export default __exports__